import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    paragraph: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.5)`,
    heading: p => p.tertiaryDark,
    background: p => p.tertiaryDark,
    blockBackground: p => `rgba(${hexToRgb(p.accentWhite)}, 0.95)`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    paragraph: p => `rgba(${hexToRgb(p.accentWhite)}, 0.5)`,
    heading: p => p.accentWhite,
    background: p => p.tertiaryLight,
    blockBackground: p => `rgba(${hexToRgb(p.primaryDark)}, 0.95)`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    paragraph: p => `rgba(${hexToRgb(p.accentWhite)}, 0.5)`,
    heading: p => p.accentWhite,
    background: p => p.tertiaryExtraLight,
    blockBackground: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.95)`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
